import axios from 'providers/axios'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import useShowError from './useShowError'
import { URL_APP } from 'helpers/config'

export type LoginStatusResponse =
  | {
      isLoggedIn: true
      redirectUrl: string
    }
  | {
      isLoggedIn: false
      authDevices: AuthDeviceInfo[]
    }

export type AuthDeviceInfo = {
  id: string
  user: {
    id: string
    email: string
    name: string
    nameFile: string
  }
  hasPasskeyAuthenticator: boolean
}

const useRedirectIfLoggedIn = (redirectUrlOverride?: string) => {
  const location = useLocation()
  const showError = useShowError()

  const [loading, setLoading] = useState(true)

  // Redirect if user is logged in
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const redirectUrl = searchParams.get('redirectUrl') || URL_APP
    console.log('redirectUrl', redirectUrlOverride)
    const checkLoginStatus = async () => {
      try {
        setLoading(true)
        const { data } = await axios.post<LoginStatusResponse>('/login/status', { redirectUrl })
        if (data.isLoggedIn) {
          if (redirectUrlOverride) {
            window.location.href = redirectUrlOverride
          } else {
            window.location.href = data.redirectUrl
          }
        } else setLoading(false)
      } catch (error) {
        showError(error)
        setLoading(false)
      }
    }

    checkLoginStatus()
  }, [location.search, showError])

  return { loading }
}

export default useRedirectIfLoggedIn
